

















import { Component, Vue } from "vue-property-decorator";

@Component
export default class nanu extends Vue {
  switchDebugMode() {
    this.$store.dispatch("setDebugMode", !this.$store.state.debugMode);
  }

  mounted() {
    this.$store.dispatch("setDebugMode", false);
  }
}
